import { useQuery } from '@tanstack/react-query';
import { toolsService } from '../services/tools';

export function useAgentTools() {
  return useQuery({
    queryKey: ['agent-tools'],
    queryFn: () => toolsService.list(),
    staleTime: 5 * 60 * 1000,
  });
}
